export default __webpack_public_path__ + "./fonts/disable-sound.b7e9eefc8617bd79b92c0b34fed15ecb.svg";